import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';

export interface ColunaConfiguracao {
  def: string;
  label: string;
  visible: boolean;
  fixed: boolean;
  movable?: boolean;
  pinnedStart?: boolean;
  pinnedEnd?: boolean;
}

@Component({
  selector: 'app-configuracao-colunas-modal',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatCheckboxModule, FormsModule, DragDropModule, MatIconModule],
  templateUrl: './configuracao-colunas-modal.component.html',
  styleUrls: ['./configuracao-colunas-modal.component.css'],
})
export class ConfiguracaoColunasModalComponent {
  public pinnedStart: ColunaConfiguracao[] = [];
  public movable: ColunaConfiguracao[] = [];
  public pinnedEnd: ColunaConfiguracao[] = [];

  constructor(
    public dialogRef: MatDialogRef<ConfiguracaoColunasModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { colunas: ColunaConfiguracao[] }
  ) {
    // Determine strict order assumption: First fixed item(s) are start, last fixed item(s) are end.
    // Or specifically target 'select' and 'actions'.
    // and 'fixed' at the end as pinned end.

    // Deep copy input
    const allCols = JSON.parse(JSON.stringify(data.colunas));

    // Separate based on explicit flags or fallbacks
    // If pinnedStart is set, use it. If not, and def is 'select', assume pinnedStart?
    // Better to encourage explicit usage but default for backward compat if needed.
    // Given the user specifically asked for this, let's assume the consumer will set them.
    // But to be safe and cleaner properly:

    this.pinnedStart = allCols.filter((c: ColunaConfiguracao) => c.pinnedStart);
    this.pinnedEnd = allCols.filter((c: ColunaConfiguracao) => c.pinnedEnd);

    // Movable is everything else? Or explicit movable?
    // Usually anything not pinned is movable.
    this.movable = allCols.filter((c: ColunaConfiguracao) => !c.pinnedStart && !c.pinnedEnd);

    // Sort movable if needed or trust input order? Trust input order.
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.movable, event.previousIndex, event.currentIndex);
  }

  confirm() {
    // Reconstruct the full list in order
    const result = [...this.pinnedStart, ...this.movable, ...this.pinnedEnd];
    this.dialogRef.close(result);
  }
}
